import { useSettings } from "~/store/settings";

const getDNSSuffix = (domain: string) => {
	if (window.location.host.includes("localhost")) {
		const settings = useSettings();
		const url = settings.config?.cultures[0]?.url || "";
		return domain.replace("{sub}", url.split("betway")[1]).replace(".{tld}", url.split("betway")[1]);
	}

	const replacement = window.location.host.split("betway");
	return domain.replace(".co.tz", replacement[1]).replace("{sub}", replacement[1]).replace(".{tld}", replacement[0]);
};

export { getDNSSuffix };
